<p>crud works!</p>

<div *ngFor="let i of images; let first = first; let last = last; let odd = odd; index as idx">
  <div *ngIf="idx < 1">
    <h1> ID: {{ i.id | number }}</h1>
   
    <p> Album ID: {{ i.albumId | number }}</p>
    <p> Title: {{ i.title | uppercase}}</p>
    <p> URL: {{ i.url | lowercase}}</p>
    <p> Thumbnail URL: {{ i.thumbnailUrl | lowercase }}</p>
    
  </div>
</div>

<!--
<div *ngFor="let i of images; let first = first">
  <h1 *ngIf="first">{{ i.id }}</h1>
  
</div>

<div *ngFor="let i of images">
  <h1> {{i.title}}</h1>
</div>

<div *ngIf="firstImage">
    <h1>{{ firstImage.title }}</h1>
    <img [src]="firstImage.url" alt="" />
    <p>Primeiro ID: {{ firstImage.id }}</p>
  </div>
-->







